/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpandMSTeamsEntityRequest } from '../models/ExpandMSTeamsEntityRequest';
import type { MSTeamsEntity } from '../models/MSTeamsEntity';
import type { MSTeamsStatus } from '../models/MSTeamsStatus';
import type { MSTeamsUser } from '../models/MSTeamsUser';
import type { PaginatedResponse } from '../models/PaginatedResponse';
import type { StudyMSTeamsTarget } from '../models/StudyMSTeamsTarget';
import type { StudyMSTeamsTargetRequest } from '../models/StudyMSTeamsTargetRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MsTeamsTargetingClient {

    /**
     * Return supported MS Teams entities (users, groups) from the MS Graph API.
     * @returns MSTeamsEntity
     * @throws ApiError
     */
    public static getMsteamsEntities({
        filter,
    }: {
        /**
         * A case-insensitive search parameter for a user or team
         */
        filter: string,
    }): CancelablePromise<Array<MSTeamsEntity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/msteams/entities',
            query: {
                'filter': filter,
            },
        });
    }

    /**
     * Expand submitted MSTeams entities into their component users
     * if any exist.
     *
     * * Team IDs will result in a list of user objects being returned.
     * * User IDs will result in the single user object being returned.
     * @returns MSTeamsUser
     * @throws ApiError
     */
    public static expandMsteamsEntity({
        requestBody,
    }: {
        requestBody: ExpandMSTeamsEntityRequest,
    }): CancelablePromise<Array<MSTeamsUser>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/msteams/entities/expand',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Return status information about the current MSTeams app installation.
     * @returns MSTeamsStatus
     * @throws ApiError
     */
    public static getMsteamsStatus(): CancelablePromise<MSTeamsStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/msteams/status',
        });
    }

    /**
     * Fetch and process the requested page of MS Teams user results.
     * @returns PaginatedResponse
     * @throws ApiError
     */
    public static syncMsteamsUsers({
        cursor,
        pageSize = 100,
    }: {
        /**
         * The MS Teams API URL used to access the next page of results.
         */
        cursor?: string,
        /**
         * The maximum number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/msteams/sync-user-data',
            query: {
                'cursor': cursor,
                'pageSize': pageSize,
            },
        });
    }

    /**
     * View for interacting with study msteams targets.
     * @returns StudyMSTeamsTarget
     * @throws ApiError
     */
    public static getStudyMsteamsTargets({
        studyRef,
    }: {
        studyRef: string,
    }): CancelablePromise<Array<StudyMSTeamsTarget>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/study/{studyRef}/msteams-targets',
            path: {
                'studyRef': studyRef,
            },
        });
    }

    /**
     * View for interacting with study msteams targets.
     * @returns StudyMSTeamsTarget
     * @throws ApiError
     */
    public static createStudyMsteamsTarget({
        studyRef,
        requestBody,
    }: {
        studyRef: string,
        requestBody: StudyMSTeamsTargetRequest,
    }): CancelablePromise<StudyMSTeamsTarget> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/study/{studyRef}/msteams-targets',
            path: {
                'studyRef': studyRef,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * View for interacting with study msteams targets.
     * @returns void
     * @throws ApiError
     */
    public static deleteStudyMsteamsTargets({
        msteamsUserRef,
        studyRef,
    }: {
        /**
         * Which msteams targets to delete.
         */
        msteamsUserRef: Array<string>,
        studyRef: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/study/{studyRef}/msteams-targets',
            path: {
                'studyRef': studyRef,
            },
            query: {
                'msteamsUserRef': msteamsUserRef,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static sendStudyMsteamsMessages({
        studyRef,
        inviteOnly,
    }: {
        studyRef: string,
        /**
         * Whether we should only send first-time invitations and not follow-up reminders.
         */
        inviteOnly?: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/study/{studyRef}/msteams/send-messages',
            path: {
                'studyRef': studyRef,
            },
            query: {
                'inviteOnly': inviteOnly,
            },
        });
    }

}
